import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shiftDays'
})
export class ShiftDaysPipe implements PipeTransform {

  transform(value: number): string {
    if (value === 1) {
      return '星期一'
    } else if (value === 2) {
      return '星期二'
    } else if (value === 3) {
      return '星期三'
    } else if (value === 4) {
      return '星期四'
    } else if (value === 5) {
      return '星期五'
    } else if (value === 6) {
      return '星期六'
    } else if (value === 7) {
      return '星期日'
    }
  }
}
